import { userApi } from '@/store/api/userApi';

export const updateAssetsAllocationCache = (newData: any, userId: any) => {
  return userApi.util.updateQueryData('getAssetsAllocations', { userId }, (draft) => {
    Object.assign(draft, newData);
  });
};
